<template>
    <div v-if="item!==null">
        <div v-if="item.linkImg!==null" class="col-xs-6 col-sm-6 col-md-6">
            <div style="text-align:center;">
                <img style="display:inline-block;height:60px;border-radius:10px;"
                     class="agx-post-thumb" :src="item.imgThumb" :title="item.linkTitle">
            </div>
        </div>

        <div :class="{'col-xs-12':item.linkImg===null, 'col-xs-6 col-sm-6 col-md-6':item.linkImg!==null}">
            <div style="padding-right: 4px; padding-left: 4px;">
                <div style="text-align:center;line-height:60px;height:60px;" v-if="item.textMsg!==null && item.textMsg!==''">
                    <div>
                        <a :href="item.linkUrl" :target="target">
                            <span style="display:inline-block;font-size:40px;height:40px;width:40px;margin:4px;" class="glyphicon glyphicon-link"></span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xs-12" style="text-align: center;">
            <div>
                <span style="font-weight:bold;">{{item.linkTitle}}</span>
            </div>
            <div style="white-space:pre-line;">{{item.linkText}}</div>
        </div>
    </div>
</template>
<script>

    export default {
        components: {

        },
        props: {
            "item": { type: Object, default: null },
            "target":{type: String, default:'_blank'}
        },
        data: function () {
            return {

            }
        },
        mounted: function () {

        }
    }
</script>